export default "__VITE_ASSET__Bcu78_zq__"